export default "__VITE_ASSET__Dvha1gw0__"